import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import icon from "../../../assets/request-submittted-modal-icon.png";
function RequestSubmittedModal({ show, handleClose }) {
  return (
    <Modal
      show={show}
      //   onHide={handleClose}
      centered
      onHide={handleClose}
      className={`delete-schedule-modal`}
    >
      <Modal.Body className="delete-schedule-modal-body px-4 ">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="confirm-redeem-modal-icon-container mt-2 mb-4">
            <img src={icon} alt="icon" className="confirm-redeem-modal-icon" />
          </div>
          <h1 className="request-submitted-modal-title mb-1">Request submitted</h1>
          <p className="delete-text-sub-label">
            Review request has been submitted to the customer by email.
          </p>
          <div className="delete-modal-btn-group d-flex">
            <button
              onClick={handleClose}
              className="w-100 delete-schedule-confirm"
            >
              Ok
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RequestSubmittedModal;
